/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Roledefault1Inputs */

const en_entity_roledefault1 = /** @type {(inputs: Entity_Roledefault1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role Default`)
};

const de_entity_roledefault1 = /** @type {(inputs: Entity_Roledefault1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rollen-Standard`)
};

/**
* | output |
* | --- |
* | "Role Default" |
*
* @param {Entity_Roledefault1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_roledefault1 = /** @type {((inputs?: Entity_Roledefault1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Roledefault1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_roledefault1(inputs)
	return de_entity_roledefault1(inputs)
});
export { entity_roledefault1 as "entity_roleDefault" }